(() => {
  if (window.__idendTrackingReady) return;
  window.__idendTrackingReady = true;
  const dataLayer = window.dataLayer = window.dataLayer || [];
  const pagePath = window.location.pathname;
  // GA4 property 515245806 stream 13088153509, verified in GA4 admin.
  // Do not initialize another Google tag or issue a second page_view.
  const measurementId = 'G-KH7X94MTG3';
  const pendingKey = 'idend_contact_pending_v2';
  const previewMode = () => Boolean(window.Shopify?.designMode
    || window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main'
    || document.getElementById('shopify-preview-bar-iframe')
    || new URLSearchParams(window.location.search).has('preview_theme_id'));
  const permitted = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed();
  };
  const pushEvent = (eventName, parameters = {}) => {
    if (previewMode() || !permitted()) return;
    const safe = {page_path:pagePath, theme_preview:false, ...parameters};
    dataLayer.push({event:eventName, ...safe});
    // Current GTM has no custom-event triggers for these names. Route to its existing destination.
    // If these events are later configured in GTM, remove this bridge to avoid duplicate delivery.
    const gtag = typeof window.gtag === 'function' ? window.gtag : function(){ dataLayer.push(arguments); };
    gtag('event', eventName, {send_to:measurementId, ...safe});
  };
  const getPosition = id => id.includes('mobile_bar') ? 'mobile_bar' : id.includes('header') ? 'header' : id.includes('footer') ? 'footer' : id.includes('article') ? 'article' : 'body';
  const getLocationId = target => {
    const href = target instanceof HTMLAnchorElement ? target.getAttribute('href') || '' : '';
    const numbers = {'0178320617':'hachinohe','0178518951':'creators','0176586257':'towada'};
    if(href.startsWith('tel:')) return numbers[href.replace(/\D/g,'')] || 'unspecified';
    const section = target.closest('#hachinohe, #creators, #towada');
    return section ? section.id : 'unspecified';
  };
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target.closest('[data-tracking], a[href^="tel:"], a[href*="line.me"], a[href*="google.com/maps"], a[href*="maps.google.com"]') : null;
    if (!(target instanceof HTMLElement)) return;
    const id = target.dataset.tracking || '';
    if(id.startsWith('form_submit')) return;
    const href = target instanceof HTMLAnchorElement ? target.getAttribute('href') || '' : '';
    const params = {element_id:id || 'site_link',position:getPosition(id),location_id:getLocationId(target)};
    if(href.startsWith('tel:')) pushEvent('tel_tap', params);
    else if(href.includes('line.me')) pushEvent('line_tap', params);
    else if(href.includes('google.com/maps') || href.includes('maps.google.com')) pushEvent('map_tap', params);
    else if(href.includes('/pages/contact') || id.startsWith('reserve_click')) pushEvent('reserve_click',params);
    else if(id.startsWith('example_copy')) pushEvent('example_copy',params);
  });
  const setup = () => {
    const form = document.getElementById('idend-btype-contact-form');
    form?.addEventListener('submit', event => {
      if(event.defaultPrevented || !form.checkValidity()) return;
      const topic = document.getElementById('BtypeContactTopic')?.value || '';
      const category = /採用/.test(topic) ? 'career' : /企業|クラウド|システム/.test(topic) ? 'business' : 'service';
      try {window.sessionStorage.setItem(pendingKey, JSON.stringify({category, at:Date.now()}));} catch (_) {}
    });
    if(document.querySelector('[data-idend-contact-success="true"]')) {
      try {
        const raw=window.sessionStorage.getItem(pendingKey);
        if(raw) {
          const pending=JSON.parse(raw);
          window.sessionStorage.removeItem(pendingKey);
          if(['service','business','career'].includes(pending.category) && Date.now()-pending.at>=0 && Date.now()-pending.at<1800000) {
            pushEvent('idend_contact_success',{form_id:'btype_contact',inquiry_category:pending.category});
          }
        }
      } catch (_) {}
    }
    if('IntersectionObserver' in window) {
      ['hachinohe','creators','towada'].forEach(locationId=>{
        const element=document.getElementById(locationId);if(!element)return;
        const observer=new IntersectionObserver(entries=>{
          if(!entries.some(e=>e.isIntersecting))return;
          pushEvent('location_anchor_view',{location_id:locationId});observer.disconnect();
        },{threshold:.35});observer.observe(element);
      });
    }
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup); else setup();
})();
